module.exports = __webpack_public_path__ + "static/media/Logo.7d44b9cb.jpg";